import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { isNonEmptyVariable } from "@/util/common_function";
export let staffList = [];
// fetch all criteria rules for a group
export const fetchStaffListAll = createAsyncThunk(
  "staff/fetchAll",
  async () => {
    const { data } = await api.get(`${API_ENDPOINTS.staff.getAll}`);
    // if(isNonEmptyVariable(data)){
    //   staffList=[...data]
    // }
    return data;
  }
);

export const fetchStaffListAllActive = createAsyncThunk(
  "staff/fetchAllActive",
  async () => {
    const { data } = await api.get(
      `${API_ENDPOINTS.staff.getAll}?isActive=true`
    );
    // if(isNonEmptyVariable(data)){
    //   staffList=[...data]
    // }
    return data;
  }
);
// fetch one by ID
export const fetchStaffById = createAsyncThunk(
  "staff/fetchById",
  async (id) => {
    const { data } = await api.get(API_ENDPOINTS.security.staff.staffByID + id);
    return data;
  }
);

// create
export const createStaff = createAsyncThunk("staff/create", async (payload) => {
  const { data } = await api.post(API_ENDPOINTS.security.staff.create, payload);
  return data;
});

// update
export const updateStaff = createAsyncThunk("staff/update", async (payload) => {
  const { data } = await api.post(API_ENDPOINTS.security.staff.update, payload);
  return data;
});

// delete
export const deleteStaff = createAsyncThunk("staff/delete", async (id) => {
  await api.delete(API_ENDPOINTS.staff.delete + id);
  return id;
});

export const fetchAllSecurityListOfStaff = createAsyncThunk(
  "staff/fetchSecurity",
  async (id) => {
    let data = await api.get(
      API_ENDPOINTS.security.staffGroupMembers.getAllStaffGroup + id
    );
    return data;
  }
);

export const fetchJudgeListAll = createAsyncThunk(
  "staff/fetchJudgeListAll",
  async () => {
    const { data } = await api.get(`${API_ENDPOINTS.judgeList}`);
    return data;
  }
);
